import { withAuthenticationRequired } from '@auth0/auth0-react';
import { Outlet } from 'react-router-dom';
import LoadingIndicator from '../common/LoadingIndicator';

export default withAuthenticationRequired(Outlet, {
	onRedirecting: () => <div style={{width: '120%', height: '110%'}}><LoadingIndicator /></div>,
	returnTo: window.location.origin
});